import { SuggestedLocation } from "Bands/components";
import { IEventSuggestedLocation } from "Bands/types";
import { ISelectOption } from "shared/components/Form/Fields/select/types";
import { DateFormat } from "shared/utils";

export const getSuggestedLocationsOptions = ({
  title,
  locations,
  dateFormat,
  alwaysShow,
}: {
  title?: string;
  locations?: IEventSuggestedLocation[];
  dateFormat: DateFormat;
  alwaysShow?: boolean;
}): ISelectOption[] => {
  let options = [];

  if (!locations?.length) return [];

  if (title) {
    options.push({
      value: "label",
      label: title,
      alwaysShow: true,
      isLabel: true,
    });
  }

  return [
    ...options,
    ...locations?.map(({ id, location, secondaryText, ...rest }) => ({
      value: id,
      label: location,
      searchableLabel: `${location} ${secondaryText}`,
      alwaysShow,
      labelComponent: (
        <SuggestedLocation
          {...rest}
          id={id}
          location={location}
          secondaryText={secondaryText}
          dateFormat={dateFormat}
        />
      ),
    })),
  ];
};
